import {FixLink} from "@/elements-react/fix-link";
import {Icon} from "@/elements-react/fix-icon";
import {googleEvent} from "@/helpers/google-events.ts";
import {Url} from "@/helpers/url.ts";
import {LayoutStyleTypes} from "@/util-react/layout.tsx";
import arrowOutlined from "@/assets/arrow-outlined.svg";
import styles from "./back-shopping-link.module.scss";
import {useTranslation} from "react-i18next";

export const BackShoppingLink = () => {
    const { t } = useTranslation();

    return (
        <FixLink
            className={styles["back-link"]}
            href={Url.to("home-page-with-lang")}
            type={LayoutStyleTypes.TYPE_SM}
            onClick={() => googleEvent("continue_shopping_click")}
        >
            <div className={styles["back-link-content"]}>
                <Icon src={arrowOutlined as string} />
                <span>{t("k0q7l2w2q1856v4o.continue-shopping", "Continue shopping")}</span>
            </div>
        </FixLink>
    )
};